<template>
    <div id="container" class="main-container">
        <!-- 공약 및 사업 -->
        <Biz/>

        <div class="main-content">
            <!-- 자원순환 센터 -->
            <RecycleCard/>
            <!-- 실시간 도시 현황 -->
            <Realtime/>
            <!-- 은평 인터넷 방송 -->
            <InternetTv/>
            <!-- 바로가기 아이콘 -->
            <ShortCut/>
        </div>
    </div>
</template>

<script>
import Biz from "@/views/main/Biz.vue";
import RecycleCard from '@/views/biz/RecycleCard.vue';
import CovidSummary from '@/views/main/CovidSummary.vue';
import Realtime from '@/views/main/Realtime.vue';
import InternetTv from '@/views/main/InternetTv';
import ShortCut from '@/views/main/ShortCut';

export default {
    name: 'Main',
    components: {
        Biz,
        RecycleCard,
        CovidSummary,
        Realtime,
        InternetTv,
        ShortCut,
    },
}
</script>
